<template>
    <div class="active-item fl" @click="openPage">

        <v-image class="active-post" :src="data.picture" />

        <div class="cf active-star">

            <div class="fl star-name">{{ data.star_name }}</div>

            <div
                class="fr star-btn"
                :class="[ data.status === 2 ? 'active_ing' : 'actived' ]"
            >{{ data.status === 1 ? '活动未开始' : data.status === 2 ? '活动进行中' : '活动已结束' }}</div>

        </div>

        <div class="active-star-title line1">{{ data.title }}</div>

        <div class="active-star-info" :style="{color: data.status === 2 ? '#8F5FF5' : '#999999'}">

            <span>活动内容：{{ data.type === 1 ? '福利' : '应援' }}</span>

            <span>人数：{{ data.join_count }}</span>

            <span>时间：{{ data.start_time }}-{{ data.end_time }}</span>

        </div>

    </div>
</template>

<script>
import mixin from "./mixin/mixin";
import vImage from '@/components/image';
export default {
    name: "layout-active-item",
    mixins: [mixin],
    components: {
        vImage
    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            }
        }
    }
}
</script>

<style scoped src="./style.css"></style>
